import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import VanguardiaEnNegroYAmarillo from "./sections/VanguardiaEnNegroYAmarillo";
import MyMissionForTheVoiceless from "./sections/MyMissionForTheVoiceless";
import SuccessStoriesInMotion from "./sections/SuccessStoriesInMotion";
import QualityFirst from "./sections/QualityFirst";
import CooperationProcess from "./sections/CooperationProcess";
import ClientSuccessStories from "./sections/ClientSuccessStories";
import ReadyForADeviceUpgrade from "./sections/ReadyForADeviceUpgrade";
import AiTextSummarizer from "./sections/AiTextSummarizer";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <VanguardiaEnNegroYAmarillo />
      <MyMissionForTheVoiceless />
      <SuccessStoriesInMotion />
      <AiTextSummarizer />
      <QualityFirst />
      <CooperationProcess />
      <ClientSuccessStories />
      <ReadyForADeviceUpgrade />
      <Footer />
    </div>;
}